/**
 * Authorization header for direct `fetch` calls.
 *
 * Most requests go through the shared api client, which attaches the session
 * token itself. A handful of blob-storage calls use `fetch` directly and need
 * the same header, since those routes require a session.
 */
export const authHeaders = (
  base: Record<string, string> = {}
): Record<string, string> => {
  try {
    const token = localStorage.getItem('auth_token');
    return token ? {...base, Authorization: `Bearer ${token}`} : {...base};
  } catch {
    // Storage can be unavailable (private mode, blocked cookies).
    return {...base};
  }
};
